(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const COUNTDOWN_SEL =
    '[class*="countdown_announcement_bar_wrapper"].top_page, [class*="countdown_annoucement_bar_wrapper"].top_page';

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.onHeightChange = () => {
        cancelAnimationFrame(this._heightRaf);
        this._heightRaf = requestAnimationFrame(() => this.setHeaderHeight());
      };

      this.resizeObserver = new ResizeObserver(this.onHeightChange);
      this.resizeObserver.observe(this.header);
      for (let el = this.header.previousElementSibling; el; el = el.previousElementSibling) {
        if (el.classList.contains('shopify-section-group-header-group')) this.resizeObserver.observe(el);
      }

      this.setHeaderHeight();

      if (!document.querySelector(COUNTDOWN_SEL)) {
        this.mutationObserver = new MutationObserver(() => {
          const cd = document.querySelector(COUNTDOWN_SEL);
          if (!cd) return;
          this.mutationObserver.disconnect();
          this.resizeObserver.observe(cd);
          this.setHeaderHeight();
        });
        this.mutationObserver.observe(document.body, { childList: true });
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      const root = document.documentElement;
      const countdown = document.querySelector(COUNTDOWN_SEL);
      const announcement = document.querySelector('.announcement-bar-section');
      const cdH = countdown?.offsetHeight || 0;
      const hasAnn = !!(announcement?.offsetHeight && announcement.querySelector('.announcement-bar, .utility-bar'));
      const annH = hasAnn ? announcement.offsetHeight : 0;
      const headerH = this.header.offsetHeight;

      root.style.setProperty('--header-height', `${headerH}px`);
      root.style.setProperty('--countdown-height', `${cdH}px`);
      root.style.setProperty('--announcement-height', `${annH}px`);
      root.style.setProperty('--header-stack-height', `${cdH + annH + headerH}px`);

      announcement?.classList.toggle('tsw-stack-bar', hasAnn);
      if (countdown) this.resizeObserver.observe(countdown);

      if (!this._spacer) {
        this._spacer = document.createElement('div');
        this._spacer.className = 'tsw-header-stack-spacer';
        this._spacer.setAttribute('aria-hidden', 'true');
        this.header.after(this._spacer);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      cancelAnimationFrame(this._heightRaf);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      document.documentElement.classList.toggle('is-header-stuck', scrollTop > 0);

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
